export enum API_TYPES {
  BVA_API_URL = 'BVA_API_URL',
  MT_API_URL = 'MT_API_URL',
  API_BASE_URL = 'API_BASE_URL',
}

const developmentApi: Record<API_TYPES, string> = {
  BVA_API_URL: 'https://bva-api.dev.mos.coke.com/v1',
  MT_API_URL: 'https://mt-api.dev.mos.coke.com/v2',
  API_BASE_URL: 'https://user-profile-api.dev.mos.coke.com',
}

const productionApi: Record<API_TYPES, string> = {
  BVA_API_URL: '',
  MT_API_URL: 'MT_API_URL',
  API_BASE_URL: 'API_BASE_URL',
}

const config = Object.keys(API_TYPES).reduce(
  (acc, type) => {
    const api =
      process.env.NODE_ENV !== 'development'
        ? process.env[`REACT_APP_${type}`] || productionApi[type as API_TYPES]
        : developmentApi[type as API_TYPES]
    return { ...acc, [type]: api }
  },
  {} as Record<API_TYPES, string>,
)

export default config
